import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Producteur from '../Producteur'
import injectSheet from 'react-jss'
import { withCookies } from 'react-cookie'
import routes from '../../routing/routes'
import ButtonLink from '../button/ButtonLink'
import SearchBarMobile from '../top_bar/SearchBarMobile'
import styles from './ListeProducteurs.styles'
import { withRouter } from 'react-router'
import HeaderPagination from '../HeaderPagination'
import responsiveComponent from 'src/hoc/responsiveComponent'
import Paginator from '../Paginator'
import Spinner from '../Spinner'
import { responsiveAd, smBannerAd } from '../../config/dataConf'
import PubContainer from '../PubContainer'

const listProducers = ({
  classes,
  resultatsRecherche,
  nbProdParPage,
  page,
  cookies,
  match,
  isMobile,
  loading,
  ...props
}) => {
  const nbPages = resultatsRecherche
    ? Math.ceil(resultatsRecherche.nbRes / nbProdParPage)
    : 0

  const token = cookies.get('token')

  const producersForPage =
    !loading && resultatsRecherche
      ? resultatsRecherche.producers.filter(
          (producer, i) =>
            i >= page * nbProdParPage - nbProdParPage &&
            i < page * nbProdParPage
        )
      : []

  let url = match.path
  let hasParamUrl = false

  for (const value in match.params) {
    if (match.params.hasOwnProperty(value) && value !== 'page') {
      url = url.replace(':' + value, match.params[value])
    } else {
      hasParamUrl = true
    }
  }

  const producers = !loading ? (
    producersForPage.map((producteur, i) => {
      if (i > 0 && i % 4 === 0) {
        return (
          <div key={i}>
            <PubContainer scriptPubCore={smBannerAd} className={classes.pub} />
            <hr className={classes.hrPub} />
            <Producteur
              id={producteur.id}
              presentation={producteur.presentation}
              photoUrlProducer={producteur.photoProducerUrl}
              companyName={producteur.companyName.toUpperCase()}
              commune={producteur.addressCity}
              dep={producteur.addressPostalCode.slice(0, 2)}
              categories={producteur.categories}
              isLast={i === resultatsRecherche.producers.length - 1}
            />
          </div>
        )
      } else {
        return (
          <Producteur
            key={i}
            id={producteur.id}
            presentation={producteur.presentation}
            photoUrlProducer={producteur.photoProducerUrl}
            companyName={producteur.companyName.toUpperCase()}
            commune={producteur.addressCity}
            dep={producteur.addressPostalCode.slice(0, 2)}
            categories={producteur.categories}
            isLast={i === resultatsRecherche.producers.length - 1}
          />
        )
      }
    })
  ) : (
    <Spinner />
  )

  return (
    <Fragment>
      {match.params && match.params.page && (
        <HeaderPagination
          urlPage={match.path}
          urlProps={match.params}
          maxPage={nbPages + 1}
        />
      )}
      {isMobile ? (
        <div className={classes.colProd}>
          {!loading && resultatsRecherche && (
            <div>
              <SearchBarMobile resultatsRecherche={resultatsRecherche} />
              <hr className={classes.hr} />
            </div>
          )}
          <div className={classes.prodContainer}>
            {isMobile && (
              <PubContainer
                className={classes.pub}
                scriptPubCore={responsiveAd}
              />
            )}
            {!token && (
              <div className={classes.buttonProducteur}>
                <ButtonLink jaune to={routes.inscription}>
                  Vous êtes producteurs ?
                </ButtonLink>
              </div>
            )}

            {producers}

            {!loading &&
              resultatsRecherche &&
              resultatsRecherche.nbRes !== 0 && (
                <Paginator
                  className={classes.pagination}
                  indexPage={page - 1}
                  nbOfPages={nbPages}
                  urlTemplate={
                    hasParamUrl
                      ? url
                      : `${props.location.pathname}${props.location.search}`
                  }
                />
              )}
          </div>
        </div>
      ) : (
        // <<<<<<<<<< Desktop >>>>>>>>>>
        <div className={classes.colProdAF}>
          {!token && (
            <div className={classes.buttonProducteur}>
              <ButtonLink jaune to={routes.inscription}>
                Vous êtes producteurs ?
              </ButtonLink>
            </div>
          )}
          <p className={classes.texteResultatsAutreFormat} id={'listeProd'}>
            {!loading && resultatsRecherche ? (
              `${resultatsRecherche.nbRes} résultats pour votre recherche`
            ) : (
              <br />
            )}
          </p>
          <div className={classes.divProd}>
            {!loading &&
            resultatsRecherche &&
            resultatsRecherche.nbRes === 0 ? (
              <div>Aucun résultat</div>
            ) : (
              ''
            )}

            {producers}

            {!loading &&
              resultatsRecherche &&
              resultatsRecherche.nbRes !== 0 && (
                <Paginator
                  className={classes.pagination}
                  indexPage={page - 1}
                  nbOfPages={nbPages}
                  urlTemplate={
                    hasParamUrl
                      ? url
                      : `${props.location.pathname}${props.location.search}`
                  }
                />
              )}
          </div>
        </div>
      )}
    </Fragment>
  )
}

listProducers.propTypes = {
  nbProdParPage: PropTypes.any,
  page: PropTypes.any,
  resultatsRecherche: PropTypes.any,
  url: PropTypes.any
}

const withStyles = injectSheet(styles)(listProducers)
export default responsiveComponent(withCookies(withRouter(withStyles)))
